import React from 'react';
import Search from './components/SearchField';
import CountOfItem from './components/CountOfItem';
import SortBy from './components/SortBy/SortBy';
import style from './UpdateHistoryControlPanel.module.scss';

const UpdateHistoryControlPanel: React.FC = () => {
	return (
		<div data-test="UpdateHistoryControlPanel">
			<div className={style.firstRowWithControls}>
				<Search />
			</div>
			<div className={style.secondRowWithControls}>
				<SortBy />
				<CountOfItem />
			</div>
		</div>
	);
};

export default UpdateHistoryControlPanel;
